import { computed, defineComponent, ref, } from '@vue/composition-api';
import SurveyQuestionReadonly from './SurveyQuestionReadonly.vue';
import Vue from 'vue';
import SurveyModalShell from './SurveyModalShell.vue';
export default defineComponent({
    name: 'SurveyAnswersAcceptanceModal',
    components: {
        SurveyQuestionReadonly,
        SurveyModalShell,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        place: {
            type: Object,
            default: null,
        },
        userFullName: {
            type: String,
            default: null,
        },
        show: Boolean,
        canManageStatus: {
            type: Boolean,
            default: false,
        },
        surveyUserId: {
            type: String,
            default: null,
        },
        statuses: {
            type: Array,
            default: null,
        },
    },
    setup(props, ctx) {
        const questionLoadingStates = ref({});
        const isLoading = computed(() => Object.values(questionLoadingStates.value).some(Boolean));
        const updateShow = () => {
            ctx.emit('close');
        };
        const handleStatusChange = (questionIndex, newStatus) => {
            ctx.emit('status-changed', questionIndex, newStatus);
        };
        return {
            isLoading,
            questionLoadingStates,
            updateShow,
            handleStatusChange,
            handleChangeQuestionLoading: ({ id, value, }) => {
                Vue.set(questionLoadingStates.value, id.value, value);
            },
        };
    },
});
